
class GuestAddressing extends HTMLElement {
  constructor() {
    super()
    this.variantField = this.querySelector('input[type="hidden"]')
    this.additionalFields = this.querySelector('.additional-fields')
    this.guestAddressingCheckbox = this.querySelector('input[type="checkbox"]')
    this.guestAddressingInkColor = this.querySelector('#guest-addressing-ink-color')
    this.quantitySelector = this.querySelector('#guest-addressing-quantity')
    this.guestAddressingPrice = this.querySelector('#GuestAddressingQuantityPrice')
  }

  connectedCallback() {
    this.guestAddressingCheckbox.addEventListener('change', this.toggleAdditionalFields.bind(this))
    this.quantitySelector.addEventListener('change', this.handleQuantityChange.bind(this))
  }

  handleQuantityChange() {
    this.updateOptions()
    this.updateMasterId()
    if (!this.currentVariant) return
    this.updateVariantInput()
    this.variantSelects = document.querySelector('variant-radios')
    this.variantSelects.updateOptions()
    this.variantSelects.updateMasterId()
    this.selectedVariant = this.variantSelects.getCurrentVariant()
    this.updatePrice()
    this.toggleBuyButtonPrice()
  }

  toggleAdditionalFields(e) {
    if (e.target.checked) {
      this.additionalFields.removeAttribute('hidden')
    } else {
      this.toggleBuyButtonPrice('remove')
      this.guestAddressingPrice.textContent = ''
      this.quantitySelector.value = ''
      this.guestAddressingInkColor.value = ''
      this.additionalFields.setAttribute('hidden', '')
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelector('.product-form__options').querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getProductData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantInput() {
    if (!this.variantField) return;
    this.variantField.value = this.currentVariant.id;
  }

  updatePrice() {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    this.guestAddressingPrice.textContent = `(+${formatter.format((this.currentVariant.price) / 100).replace('.00', '')})`
  }

  toggleBuyButtonPrice(event = 'add') {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    if (event === 'add') {
      const gaVariantPrice = this.currentVariant.price
      const productVariantPrice = this.selectedVariant.price
      document.querySelectorAll('#price_buy').forEach(btn => {
        btn.textContent = `${formatter.format((gaVariantPrice + productVariantPrice) / 100).replace('.00', '')}`
      })
    } else {
      const productVariantPrice = this.selectedVariant?.price || 0
      document.querySelectorAll('#price_buy').forEach(btn => {
        btn.textContent = `${formatter.format((productVariantPrice) / 100).replace('.00', '')}`
      })
    }
  }

  getProductData() {
    this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.productData
  }
}

customElements.define('guest-addressing', GuestAddressing);
